import * as core from '../../../../../core'
import * as employeeOrg from '../apps/employee-planning/pages/employee-org'

export const RESOURCE = {
  payload: {
    agentId: core.agent.Agent.Id.Mosaic,
    pageContext: {
      isForNonPrebuiltPages: true,
      pageAliases: [employeeOrg.RESOURCE.payload.alias],
    },
  },
  type: core.quiver.Resource.Type.Agent,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.Agent>
